<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div style="margin-bottom: 50px;">
      <form [formGroup]="agregarForm" mat-dialog-content>
        <div class="col-12">
          <div class="row">
            <div class="col-6" style="float: left;">
              <div class="mb-2">
                <label for="proveedor">Proveedor</label>
                <input autocomplete="off" class="form-control" formControlName="proveedor" name="proveedor" type="text">
              </div>
              <div *ngIf="proveedorInvalido" class="text-danger">
                <small>*Este proveedor es inválido</small>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-2">
                <label for="">Desc. Proveedor</label>
                <input autocomplete="off" class="form-control" formControlName="despro" name="despro" readonly
                  type="text">
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-12" style="float: left;">
          <label>Tipo Reporte</label>
          <select class="form-control" formControlName="estado" name="estado">
            <option value="0">Acidez</option>
            <option value="1">Humedad + Impureza</option>
          </select>
        </div> -->
      </form>
      <div class="btn-group-justified btn-group" style="float: right;bottom: -24px;margin-left: 10px;">
        <button class="btn btn-success" (click)="descargarExcel()">
          <i aria-hidden="true" class="fa fa-file-export"></i>
          Exportar CSV
        </button>
      </div>
      <div class="btn-group-justified btn-group" style="float: right;bottom: -24px;">
        <button class="btn btn-success" (click)="procesar()">
          <i aria-hidden="true" class="fa fa-play"></i>
          Procesar
        </button>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
      [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
      [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>